import { ChartConfig } from '../ui/chart';

/** Canonical display order for the A–E carbon rating buckets. */
export const RATING_ORDER = ['A', 'B', 'C', 'D', 'E'] as const;

/** A–E carbon-rating series, keyed and labelled by rating letter. */
export const ratingsChartConfig = {
  A: {
    label: 'A',
    color: 'var(--rating-a)',
  },
  B: {
    label: 'B',
    color: 'var(--rating-b)',
  },
  C: {
    label: 'C',
    color: 'var(--rating-c)',
  },
  D: {
    label: 'D',
    color: 'var(--rating-d)',
  },
  E: {
    label: 'E',
    color: 'var(--rating-e)',
  },
} satisfies ChartConfig;

/**
 * Low/Medium/High carbon-intensity tiers (used for packaging items).
 * Keys map onto the A/C/E rating colour tokens.
 */
export const intensityChartConfig = {
  A: {
    label: 'Low',
    color: 'var(--rating-a)',
  },
  C: {
    label: 'Medium',
    color: 'var(--rating-c)',
  },
  E: {
    label: 'High',
    color: 'var(--rating-e)',
  },
} satisfies ChartConfig;

export const itemsByRatingChartConfig = {
  items: {
    label: 'Items',
  },
  ...ratingsChartConfig,
} satisfies ChartConfig;

export const itemsByIntensityChartConfig = {
  items: {
    label: 'Items',
  },
  ...intensityChartConfig,
} satisfies ChartConfig;
